import { createApp } from 'vue';
import { createPinia } from 'pinia';
import faqSpecificationAccordionApp from '@/app/views/faq-specification-accordion/faq-specification-accordion.vue';
import { pushToDataLayer } from '@/js/analytics/analytics.methods';

export default class faqSpecificationAccordion {
  constructor(el) {
    this.el = el;
    this.init();
  }
  init() {
    const app = createApp(faqSpecificationAccordionApp);
    const pinia = createPinia();

    app.provide('config', JCB);
    app.provide('gaPush', pushToDataLayer);
    app.use(pinia);
    app.mount(this.el);
  }
}
